import useStoryblokLink from "./useStoryblokLink";

export default useStoryblokLink;
